// 진행 상태 전체 이름. 평가 관리(AdminAssessment) 필터·배지와 기업 상세 배지가 같은 단어를 쓴다.
// supplement = in_progress 이면서 in_assessment_ts 가 있는 건(평가 시작 뒤 보완요청으로 되돌아감)
export const STATUS_LABELS = {
    not_requested: '미신청',
    requested: '평가신청',
    in_progress: '답변중',
    supplement: '보완요청',
    in_assessment: '평가중',
    re_progress: '재답변중',
    completed: '평가완료',
    canceled: '평가취소',
    eco_vadis: '에코바디스'
};

// getProgressStatus 의 한 글자 약어 → STATUS_LABELS 키
const PROGRESS_LABEL_KEYS = {
    '에': 'eco_vadis',
    '미': 'not_requested',
    '신': 'requested',
    '답': 'in_progress',
    '보': 'supplement',
    '평': 'in_assessment',
    '완': 'completed',
    '취': 'canceled'
};

// 한 글자 약어 → 표 안 상태 글자색(ds-status-<variant>). 옛 배지 색(progress_bg)과 같은 뜻
//   에코바디스 회색 · 미신청 주황 · 신청 초록 · 답변중 파랑 · 보완 정보 · 평가중 빨강 · 완료 진한 글자 · 취소 흐린 글자
export const PROGRESS_TONE = {
    '에': 'secondary',
    '미': 'warning',
    '신': 'success',
    '답': 'primary',
    '보': 'info',
    '평': 'danger',
    '완': 'dark',
    '취': 'light'
};

export default {
    data () {
        return {
            progress_ko: {
                eco_vadis: '에',
                requested: '신',
                completed: '완',
                in_assessment: '평',
                in_reprogress: '보',
                in_progress: '답',
                canceled: '취'
            },
            progress_bg: {
                '에': 'secondary',
                '미': 'warning',
                '신': 'green',
                '완': 'black-medium',
                '평': 'red',
                '답': 'blue-basic',
                '보': 'blue-dark',
                '취': 'red5'
            },
            status_sort_order: {
                not_requested: 0,
                requested: 1,
                in_progress: 2,
                in_assessment: 3,
                in_reprogress: 4,
                completed: 5,
                eco_vadis: 6
            },
            status_sort_order_ko: {
                '미': 0,
                '신': 1,
                '평': 2,
                '답': 3,
                '보': 4,
                '완': 5,
                '취': 6,
                '에': 7
            }
        };
    },
    computed: {},
    created () {},
    mounted () {},
    methods: {
        getProgressStatus(company){
            const _status_code = company.status_code;
            const _manual_status = company.manual_status;
            
            if (_manual_status === 'eco_vadis') {
                return '에';
            } else if (_status_code === 'in_progress') {
                const _in_assessment_ts = !company.priority
                    ? company.in_assessment_ts
                    : company.priority.in_assessment_ts;

                if(_in_assessment_ts && _in_assessment_ts !== null) {
                    return '보';
                } else {
                    return '답';
                }
            } else if (this.progress_ko[_status_code]) {
                return this.progress_ko[_status_code];
            } else {
                return '미';
            }
        },
        // 배지에 쓰는 전체 이름. 정렬·비교는 계속 getProgressStatus 의 약어를 쓴다
        getProgressStatusLabel (company) {
            const _short = this.getProgressStatus(company);
            return STATUS_LABELS[PROGRESS_LABEL_KEYS[_short]] || _short;
        },
        getProgressColor (company) {
            const _status_code = this.getProgressStatus(company);
            return this.progress_bg[_status_code];
        },
        // 표 안 상태 글자색(DS Badge plain) — ds-status-<이 값>. 옛 배지 색(progress_bg)과 같은 뜻의 bootstrap variant 로
        getProgressTone (company) {
            return PROGRESS_TONE[this.getProgressStatus(company)] || 'secondary';
        },
        sortingCompanies(_companies, opt = {}) {
            if (!_companies || !_companies.length) {
                return [];
            } else {
                let _sorted__companies = _companies.sort((a, b) => {
                    const _a_status_order = this.status_sort_order_ko[this.getProgressStatus(a.priority ? a.priority : a)];
                    const _b_status_order = this.status_sort_order_ko[this.getProgressStatus(b.priority ? b.priority : b)];
                    return _a_status_order - _b_status_order;
                });

                if (!opt.data) {
                    return _sorted__companies;    
                }

                return _sorted__companies.map(_data => ({ ..._data, ...opt.data }));
            }
        }
    }
};
